var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShrink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62259 18.0003L7.62259 18.0002L7.62247 14.4143L7.62242 12.9052L6.55545 13.9724L1.26424 19.265C1.26416 19.2651 1.26408 19.2652 1.264 19.2653C1.11723 19.4115 0.880024 19.4116 0.733127 19.2656C0.587086 19.1187 0.587176 18.8813 0.733398 18.7345C0.733474 18.7344 0.733549 18.7343 0.733624 18.7342L6.02579 13.4426L7.09288 12.3756H5.58386H1.99834C1.79143 12.3756 1.62312 12.2073 1.62312 12.0003C1.62312 11.7932 1.79143 11.625 1.99834 11.625H7.99781C8.20472 11.625 8.37303 11.7932 8.37303 12.0003V18.0003C8.37303 18.2073 8.20472 18.3756 7.99781 18.3756C7.7909 18.3756 7.62259 18.2073 7.62259 18.0003Z",
    fill: "white",
    stroke: "#38393C",
    strokeWidth: 1.25002
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3781 5.58565V7.09485L13.4452 6.02755L18.7364 0.734936C18.8831 0.588495 19.1206 0.588338 19.2676 0.734466C19.4135 0.881402 19.4134 1.11868 19.2672 1.26548C19.2672 1.26557 19.2671 1.26566 19.267 1.26575L13.9748 6.5574L12.9077 7.62438L14.4167 7.62438H18.0023C18.2092 7.62438 18.3775 7.79263 18.3775 7.99968C18.3775 8.20674 18.2092 8.37499 18.0023 8.37499H12.0028C11.7959 8.37499 11.6276 8.20674 11.6276 7.99968V1.99971C11.6276 1.79285 11.7958 1.62452 12.0029 1.62452C12.2098 1.62452 12.3781 1.79277 12.3781 1.99983V5.58565Z",
    fill: "white",
    stroke: "#38393C",
    strokeWidth: 1.25002
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShrink);
export default __webpack_public_path__ + "static/media/shrink.dc0622d31bcb7979941b7f80f8c75e4c.svg";
export { ForwardRef as ReactComponent };